import script from "./LogoMark.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoMark.vue?vue&type=script&setup=true&lang=js"

import "./LogoMark.vue?vue&type=style&index=0&id=2e35027d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e35027d"]])

export default __exports__